import { Injectable } from '@angular/core';
import { Route, Router, Routes } from '@angular/router';
import { AppConfigService } from './app-config.service';
import { DceConfig } from '../models/app-config.model';

@Injectable({ providedIn: 'root' })
export class DceRouteConfigService {
  constructor(
    private readonly router: Router,
    private readonly appConfigService: AppConfigService
  ) {}

  applyDceRoutingConfig(): void {
    const dceConfig = this.appConfigService.config.dce;
    const rewrittenRoutes = this.rewriteRoutes(this.router.config, dceConfig);
    this.router.resetConfig(rewrittenRoutes);
  }

  private rewriteRoutes(routes: Routes, dceConfig: DceConfig): Routes {
    return routes.map((route) => this.rewriteRoute(route, dceConfig));
  }

  private rewriteRoute(route: Route, dceConfig: DceConfig): Route {
    const rewritten: Route = { ...route };

    if (rewritten.children) {
      rewritten.children = this.rewriteRoutes(rewritten.children, dceConfig);
    }

    const dceKey = rewritten.data?.['dceKey'] as keyof DceConfig | undefined;
    if (!dceKey) {
      return rewritten;
    }

    const configForRoute = dceConfig[dceKey];
    if (!configForRoute) {
      console.error(`[DceRouteConfigService] No config found for dceKey: ${dceKey}`);
      return rewritten;
    }

    // Only stamp `path` on path-based routes; matcher routes can't have both (NG04014).
    if (!rewritten.matcher) {
      rewritten.path = configForRoute.baseRoute;
    }
    rewritten.data = {
      ...rewritten.data,
      bundleUrl: configForRoute.scriptUrl,
      elementTag: configForRoute.elementTag
    };

    return rewritten;
  }
}
